import { defineStore } from 'pinia';
import { fetchStructureAlerts, fetchResidents } from '@/api';
import { Alert_AlertStatus } from '@/generated/msh/resource/v1/alert_pb';

const RECENTLY_VIEWED_MAXIMUM_ITEMS = 3;
const RECENTLY_VIEWED_RESIDENTS_LABEL = 'recentlyViewedResidents';

export default defineStore({
  id: 'residents',

  state: () => ({
    list: [],
    resident: {},
    listPage: {},
    recentlyViewed:
      JSON.parse(localStorage.getItem(RECENTLY_VIEWED_RESIDENTS_LABEL)) || [],
  }),

  getters: {},

  actions: {
    async getResidentsList(parentId, filters = {}) {
      const params = { parentId, ...filters };
      const { residents, meta } = await fetchResidents(params);

      this.list = residents;
      this.listPage = meta;
    },

    async getResident(parentId) {
      const params = { parentId };
      const { residents } = await fetchResidents(params);
      const { alerts } = await fetchStructureAlerts({
        parentId,
        filter: { status: Alert_AlertStatus.WAITING_RESPONSE },
      });

      this.resident = { ...residents[0], alerts };

      return residents[0];
    },

    addResidentToRecentlyViewed(resident) {
      const recentlyViewedResident = {
        structureId: resident.structureId,
        presenceStatus: resident.presenceStatus,
        photoUrl: resident.user.photoUrl,
        displayName: resident.user?.displayName,
        label: resident.label,
      };

      this.recentlyViewed = this.recentlyViewed.filter(
        (item) => item.structureId !== recentlyViewedResident.structureId
      );

      this.recentlyViewed.unshift(recentlyViewedResident);

      this.recentlyViewed.length = Math.min(
        this.recentlyViewed.length,
        RECENTLY_VIEWED_MAXIMUM_ITEMS
      );

      this.saveListToLocalStorage();
    },

    saveListToLocalStorage() {
      const stringifiedList = JSON.stringify(this.recentlyViewed);
      localStorage.setItem(RECENTLY_VIEWED_RESIDENTS_LABEL, stringifiedList);
    },
  },
});
